const data = {
  id: 1,
  title: 'Listen and choose the correct answer.',
  subTitle: 'Nghe và chọn từ điền vào chỗ trống.',
  question: 'Linda went to the zoo by ___',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/1d890176-1643-46b6-a154-024efa5d8cae.mp3',
  answers: [
    { id: 1, answer: 'motorbike', isCorrect: false },
    { id: 2, answer: 'train', isCorrect: false },
    { id: 3, answer: 'bus', isCorrect: true },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      direction: 'vertical',
    },
  },
};

export default data;
